import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import styled from 'styled-components';
import { useRef, useEffect, useState } from 'react';

// no trellis space token equivalent
import { jsx as _jsx } from "react/jsx-runtime";
const BASE_LINE_HEIGHT = '24px';
const TruncateToRowLimit = styled(props => {
  const [isTruncated, setIsTruncated] = useState(false);
  const contentRef = useRef(null);
  const resizeObserverRef = useRef(null);
  useEffect(() => {
    const checkTruncation = () => {
      if (contentRef.current) {
        // Check if the element is actually truncated by comparing offsetHeight to scrollHeight
        const element = contentRef.current;
        const lineHeight = parseInt(getComputedStyle(element).lineHeight, 10);
        const maxHeight = lineHeight * props.rowLimit;
        setIsTruncated(element.scrollHeight > maxHeight);
      }
    };

    // Create a ResizeObserver instance for this specific component
    resizeObserverRef.current = new ResizeObserver(checkTruncation);
    if (contentRef.current) {
      resizeObserverRef.current.observe(contentRef.current);
    }
    checkTruncation();
    return () => {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }
    };
  }, [props.children, props.rowLimit]);
  const content =
  /*#__PURE__*/
  /* @bend-expect trellis-tokenized */
  _jsx("span", Object.assign({
    ref: contentRef,
    style: isTruncated ? {
      cursor: 'help'
    } : {}
  }, props));
  return isTruncated ? /*#__PURE__*/_jsx(Tooltip, {
    title: props.children,
    children: content
  }) : content;
}).withConfig({
  displayName: "TruncateToRowLimit",
  componentId: "sc-1r8oahe-0"
})(["display:-webkit-box;-webkit-line-clamp:", ";-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;min-height:", ";"], ({
  rowLimit
}) => rowLimit, ({
  rowLimit
}) => `calc(${BASE_LINE_HEIGHT} * ${rowLimit})`);
export default TruncateToRowLimit;